module.exports = {
	"webClient": "your_unique_id.apps.googleusercontent.com"
};


//////////////////
// WEBPACK FOOTER
// ./src/config/google.json
// module id = 683
// module chunks = 0